export default {
    loaded: ({invite}) => invite.loaded,
    stats: ({invite}) => invite.stats,
    referrals: ({invite}) => invite.referrals,
    buttons: {
        redeem: ({invite}) => invite.buttons.redeem
    }
}